/*=============================================== DemoPagination ===============================================*/

import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import {
    PaginationContainer,
    PaginationButton,
    Card,
    Text,
    Grid,
    uuid,
    generateNumbers,
    scrollToTop,
} from "tsx-library-julseb"

import { WrapperPagination } from "components"

const DemoCustomPagination = () => {
    const arr: string[] = generateNumbers(1, 201).map(n => `Hello ${n}`)

    const pageLimit: number = 5
    const dataLimit: number = 20

    const [searchParams, setSearchParams] = useSearchParams()
    const page: string = searchParams.get("page") || "1"

    const [currentPage, setCurrentPage] = useState<number>(parseInt(page))

    const handlePrev = () => {
        setSearchParams({ page: (currentPage - 1).toString() })
        setCurrentPage(currentPage - 1)
        scrollToTop()
    }

    const handleNext = () => {
        setSearchParams({ page: (currentPage + 1).toString() })
        setCurrentPage(currentPage + 1)
        scrollToTop()
    }

    const handlePage = (i: number) => {
        setSearchParams({ page: i.toString() })
        setCurrentPage(i)
        scrollToTop()
    }

    const totalPages: number = Math.ceil((arr?.length || 0) / dataLimit)

    const getPaginationGroup = () => {
        let start: number =
            Math.floor((currentPage - 1) / pageLimit) * pageLimit
        return (
            new Array(pageLimit)
                // @ts-expect-error
                .fill()
                .map((_, i) => start + i + 1)
                .filter(item => item <= totalPages)
        )
    }

    const getPaginatedData = () => {
        const startIndex: number = currentPage * dataLimit - dataLimit
        const endIndex: number = startIndex + dataLimit
        return arr?.slice(startIndex, endIndex)
    }

    return (
        <WrapperPagination title="Demo Pagination custom">
            {getPaginatedData() && (
                <Grid col={4} gap="s">
                    {getPaginatedData().map(text => (
                        <Card border={{ width: 1 }} key={uuid()}>
                            <Text>{text}</Text>
                        </Card>
                    ))}
                </Grid>
            )}

            {totalPages > 1 && (
                <PaginationContainer>
                    <PaginationButton
                        onClick={handlePrev}
                        buttonContent="prev"
                        disabled={currentPage === 1}
                    />

                    {getPaginationGroup()[0] !== 1 && (
                        <>
                            <PaginationButton
                                buttonContent={1}
                                onClick={() => handlePage(1)}
                            />
                            <PaginationButton buttonContent="more" />
                        </>
                    )}

                    {getPaginationGroup().map(item => (
                        <PaginationButton
                            buttonContent={item}
                            key={item}
                            onClick={() => handlePage(item)}
                            isActive={currentPage === item}
                        />
                    ))}

                    {getPaginationGroup()[getPaginationGroup().length - 1] !==
                        totalPages && (
                        <>
                            <PaginationButton buttonContent="more" />

                            <PaginationButton
                                buttonContent={totalPages}
                                onClick={() => handlePage(totalPages)}
                            />
                        </>
                    )}

                    <PaginationButton
                        onClick={handleNext}
                        buttonContent="next"
                        disabled={currentPage === totalPages}
                    />
                </PaginationContainer>
            )}
        </WrapperPagination>
    )
}

export default DemoCustomPagination
